export class Rendezvous {
  public begin: String;
  public end: String;
}



// WEBPACK FOOTER //
// ./src/app/auth/signin/rendezvous.ts